/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        ClientOrganizationVariableDistribution200ResponseInner,
        CompetitiveGameSummaries,
        CompetitiveGameSummariesAggregate,
    } from '../models/index';

            export interface CompetitiveGameSummariesAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                additional_filters?: object;
                agent?: string;
                aggregates?: Array<string>;
                date?: string;
                having?: object;
                id?: string;
                index_on?: string;
                league?: string;
                map?: string;
                metrics?: Array<string>;
                patch?: string;
                player?: string;
                team1?: string;
                team2?: string;
                win?: boolean;
            }

            export interface CompetitiveGameSummariesFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                additional_filters?: object;
                agent?: string;
                date?: string;
                id?: string;
                league?: string;
                map?: string;
                patch?: string;
                player?: string;
                team1?: string;
                team2?: string;
                win?: boolean;
            }

            export interface CompetitiveGameSummariesGetRequest {
                id: string;
            }

            export interface CompetitiveGameSummariesListRequest {
                additional_filters?: object;
                agent?: string;
                annotations?: Array<string>;
                date?: string;
                id?: string;
                league?: string;
                map?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                patch?: string;
                player?: string;
                team1?: string;
                team2?: string;
                win?: boolean;
            }

            export interface CompetitiveGameSummariesVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                additional_filters?: object;
                agent?: string;
                date?: string;
                id?: string;
                league?: string;
                map?: string;
                patch?: string;
                player?: string;
                team1?: string;
                team2?: string;
                win?: boolean;
            }

        /**
        * 
        */
            export class CompetitiveGameSummariesApi extends runtime.BaseAPI {

            /**
            */
            async competitiveGameSummariesAggregateRaw(requestParameters: CompetitiveGameSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveGameSummariesAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling competitiveGameSummariesAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveGameSummariesAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.win !== undefined) {
                            queryParameters['win'] = requestParameters.win;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGameSummaries/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: CompetitiveGameSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveGameSummariesAggregate>> {
                    const response = await this.competitiveGameSummariesAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveGameSummariesFieldValuesRaw(requestParameters: CompetitiveGameSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling competitiveGameSummariesFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveGameSummariesFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.win !== undefined) {
                            queryParameters['win'] = requestParameters.win;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGameSummaries/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: CompetitiveGameSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.competitiveGameSummariesFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveGameSummariesGetRaw(requestParameters: CompetitiveGameSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitiveGameSummaries>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling competitiveGameSummariesGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGameSummaries/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: CompetitiveGameSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitiveGameSummaries> {
                    const response = await this.competitiveGameSummariesGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveGameSummariesListRaw(requestParameters: CompetitiveGameSummariesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveGameSummaries>>> {
            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.win !== undefined) {
                            queryParameters['win'] = requestParameters.win;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGameSummaries/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: CompetitiveGameSummariesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveGameSummaries>> {
                    const response = await this.competitiveGameSummariesListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveGameSummariesVariableDistributionRaw(requestParameters: CompetitiveGameSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientOrganizationVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling competitiveGameSummariesVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling competitiveGameSummariesVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling competitiveGameSummariesVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling competitiveGameSummariesVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.win !== undefined) {
                            queryParameters['win'] = requestParameters.win;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGameSummaries/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: CompetitiveGameSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientOrganizationVariableDistribution200ResponseInner>> {
                    const response = await this.competitiveGameSummariesVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
